import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface CheckListItem {
  channel: string;
  name: string;
  checked: boolean;
}

interface SetWithCheckList {
  set_sku: string;
  name: string;
  check_list: CheckListItem[];
}

interface ChannelRow {
  channel: string;
  name: string;
  totalCount: number;
  checkedCount: number;
  desiredChecked: boolean;
}

@Component({
  selector: 'app-bulk-update-check-list',
  templateUrl: './bulk-update-check-list.component.html',
  styleUrl: './bulk-update-check-list.component.css'
})
export class BulkUpdateCheckListComponent implements OnInit {

  sets: SetWithCheckList[] = [];
  channelRows: ChannelRow[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ref: MatDialogRef<BulkUpdateCheckListComponent>
  ) { }

  ngOnInit(): void {
    this.sets = this.data.sets || [];
    this.buildChannelRows();
  }

  private buildChannelRows() {
    const map = new Map<string, ChannelRow>();
    for (const set of this.sets) {
      for (const item of (set.check_list || [])) {
        const row = map.get(item.channel);
        if (row) {
          row.totalCount++;
          if (item.checked) row.checkedCount++;
        } else {
          map.set(item.channel, {
            channel: item.channel,
            name: item.name,
            totalCount: 1,
            checkedCount: item.checked ? 1 : 0,
            desiredChecked: false,
          });
        }
      }
    }
    for (const row of map.values()) {
      row.desiredChecked = row.checkedCount === row.totalCount;
    }
    this.channelRows = [...map.values()].sort((a, b) => a.name.localeCompare(b.name));
  }

  get allFullyChecked(): boolean {
    return this.channelRows.length > 0 && this.channelRows.every(r => r.desiredChecked);
  }

  get someChecked(): boolean {
    const count = this.channelRows.filter(r => r.desiredChecked).length;
    return count > 0 && count < this.channelRows.length;
  }

  toggleAll(checked: boolean) {
    this.channelRows.forEach(r => r.desiredChecked = checked);
  }

  close() {
    this.ref.close({ confirm: false });
  }

  confirm() {
    const updates: Array<{ set_sku: string; check_list: Array<{ channel: string; checked: boolean }> }> = [];

    for (const set of this.sets) {
      const setChanges: Array<{ channel: string; checked: boolean }> = [];
      for (const row of this.channelRows) {
        const item = (set.check_list || []).find(c => c.channel === row.channel);
        if (!item) continue;
        if (item.checked !== row.desiredChecked) {
          setChanges.push({ channel: row.channel, checked: row.desiredChecked });
        }
      }
      if (setChanges.length > 0) {
        updates.push({ set_sku: set.set_sku, check_list: setChanges });
      }
    }

    this.ref.close({ confirm: true, updates });
  }
}
